import React from 'react'
import cx from 'classnames'
import { Alert as AntdAlert } from 'antd'

import styles from './SuccessAlert.module.scss'

type Props = {
  className?: string
  message?: string
}

const SuccessAlert = (props: Props) => {
  const { className, message } = props
  if (!message) return null
  const cn = cx(styles.successAlert, className)
  return <AntdAlert className={cn} message={message} type="success" />
}

export default SuccessAlert
